import React, { useState } from 'react';
import './Sidebar.scss';
import DashboardIcon from '@mui/icons-material/Dashboard';
//import FileUploadIcon from '@mui/icons-material/FileUpload';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import logo from '../../assets/logomedium.png';
import { Link } from 'react-router-dom';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import KeyboardDoubleArrowUpOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowUpOutlined';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import { featuresFlags } from '../../features/featuresFlags';
import RNModal from '../RNModal/RNModal';

const Sidebar = () => {
  const userData = JSON.parse(localStorage.getItem('user_data'));
  // const app_version = localStorage.getItem('app_version');
  const [openSection, setOpenSection] = useState(null);
  const [selectedRoute, setselectedRoute] = useState('');
  const [clickedButton, setClickedButton] = useState(null);

  const [isRNModalOpen, setIsRNModalOpen] = useState(false);
  
  const targetRoute =
    userData.role === 'manager'
      ? featuresFlags.SINGLE_DASHBOARD
        ? '/dashboard'
        : '/manager'
      : featuresFlags.SINGLE_DASHBOARD
      ? '/dashboard'
      : '/employee';
  const accordionSections = [
    {
      title: 'Home',
      links: [
        
       // { label: 'My Dashboard', path: selectedRoute}, //manager dashboard
       // { label: 'Team Progress', path: '/dashboard' }, // team performance
        { label: 'Dashboard', path: selectedRoute},
        { label: 'View Attach Rate', path: '/viewar' },
      ],
    },
    {
      title: 'Upload',
      links: [
        { label: 'CIS', path: '/cisupload' },
        { label: 'Refunds', path: '/refund' },
        { label: 'Home Internet', path: '/homeinternet' },
        { label: 'Event CIS', path: '/eventcis' },
      ],
    },

    {
      title: 'Commission',
      links: [
        { label: 'Structure', path: '/commissionstructure' },
        /* { label: 'Report', path: '/employeeCommissionReport', }, */
      ],
    },
  ];

  if (userData?.role === 'manager') {
    accordionSections.push({
      title: 'Performance',
      links: [
        { label: 'Ranking', path: '/rankingPage' },
        { label: 'Attach Rate', path: '/attachrate' },
      ],
    });
  }
  // if (userData?.role === 'employee') {
  //   accordionSections.push({
  //     title: 'Performance',
  //     links: [{ label: 'Attach Rate', path: '/attachrate' }],
  //   });
  // }

  const handleSectionClick = (index, title) => {
    setOpenSection(index === openSection ? null : index);
    if (userData?.role === 'manager' && title === 'Home') {
      setselectedRoute(featuresFlags.SINGLE_DASHBOARD ? '/dashboard' : '/manager');
    } else if (userData?.role === 'employee' && title === 'Home') {
      setselectedRoute(featuresFlags.SINGLE_DASHBOARD ? '/dashboard' : '/employee');
    }
    setClickedButton(index);
  };

  return (
    <div className="sidebar">
      <div className="top">
        <Link to={targetRoute}>
          <span className="logo">
            <img src={logo} alt="logo" />
          </span>
        </Link>
      </div>

      <div className="center">
        {accordionSections.map((section, index) => (
          <div key={index} className={`accordion-section ${openSection === index ? 'open' : ''}`}>
            <div
              className={`accordion-title ${clickedButton === index ? 'clicked' : ''}`}
              onClick={() => handleSectionClick(index, section.title)}
            >
              <div className="left">
                {section.title === 'Home' && <DashboardIcon />}
                {section.title === 'Upload' && <CloudUploadIcon />}
                {section.title === 'Commission' && <MonetizationOnIcon />}
                {section.title === 'Performance' && <MilitaryTechIcon />}
                {section.title}
              </div>

              <div className="arrow-icon ">
                {openSection === index ? (
                  <KeyboardDoubleArrowUpOutlinedIcon />
                ) : (
                  <KeyboardDoubleArrowDownOutlinedIcon />
                )}
              </div>
            </div>
            {openSection === index && (
              <div className="accordion-links">
                {section.links.map((link, linkIndex) => (
                  <div key={linkIndex} className="accordion-link">
                    <Link to={link.path}>{link.label}</Link>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
        {/* <div className="accordion-title">version: {app_version}</div>*/}

         <div className="release-notes">
         {/* <Link to="#"
          onClick={(e) => {
            e.preventDefault();
            setIsRNModalOpen(true);
          }} */}
        <div className='footer' onClick={setIsRNModalOpen}><p>View Release Notes</p></div>
        </div>
          <RNModal isOpen={isRNModalOpen} onClose={() => setIsRNModalOpen(false)} />
        
      </div>
    </div>
  );
};

export default Sidebar;
